export default __webpack_public_path__ + "static/media/025-pacifier.15650657.png";